import { Box, LinearProgress } from "@mui/material";


export function Loading(params: {
    isLoading: boolean
}) {
    return (
        !params.isLoading ? null :
            <Box sx={{ width: '100%' }}>
                <LinearProgress />
            </Box>
    )
}